/**
 * HUB-E — Filtres type mouvement.
 */
import React from 'react';

const FILTERS = [
  { key: 'all', label: 'Tous' },
  { key: 'entree', label: 'Entrées' },
  { key: 'sortie', label: 'Sorties' },
  { key: 'ajustement', label: 'Ajustements' },
];

export default function ActiviteStockMovementFilters({ value, onChange }) {
  return (
    <div className="flex gap-2 flex-wrap" data-testid="activite-stock-movement-filters">
      {FILTERS.map((f) => {
        const isActive = value === f.key;
        return (
          <button
            key={f.key}
            type="button"
            onClick={() => onChange(f.key)}
            className={`px-4 py-2.5 min-h-[44px] rounded-xl text-sm font-semibold border ${
              isActive ? 'text-[var(--rm-white)]' : 'text-[var(--rm-gray-400)]'
            }`}
            style={{
              borderColor: isActive ? 'var(--rm-border-strong)' : 'var(--rm-border-subtle)',
              background: isActive ? 'var(--rm-bg-panel)' : 'transparent',
            }}
            data-testid={`activite-stock-filter-${f.key}`}
          >
            {f.label}
          </button>
        );
      })}
    </div>
  );
}
